module.exports = __webpack_public_path__ + "media/img/logo-hub-2704910b0ac4ad9f158418a1d5275120.svg";